import React from 'react';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../../components';
import { SCREEN_NORMAL } from '../../../config/constants';
import useFacetItems from '../../../components/SearchAllContent/Facets/hooks/useFacetItems';
import SearchErrorState from '../../../components/Search/ErrorState';

const SearchResults = () => {
  const { width } = useWindowDimensions();
  const { empty: emptyFacets } = useFacetItems();

  return (
    <div className="content-section">
      <div className="row">
        {!emptyFacets && (
          <div className="col-md-4 col-lg-3 mb-10 mb-md-0">
            <SearchAllContent.Facets />
            {width < SCREEN_NORMAL && (
              <SearchAllContent.ActiveFacets className="mt-2" />
            )}
          </div>
        )}

        <div className={emptyFacets ? 'col-12' : 'col-md-8 col-lg-9 col-xl-8 offset-xl-1'}>
          {/* Hide the result count too when the search failed. */}
          <SearchErrorState>
            <SearchAllContent.Stats />
            <SearchAllContent.Results />
          </SearchErrorState>
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
